(function () {

    'use strict';

    angular.module('Services').service('LinkCompanyTableService', LinkCompanyTableService);

    LinkCompanyTableService.$inject = [
        '$location',
        'ClientService',
        'TableLiteFactory',
        'toastr'
    ];

    function LinkCompanyTableService(
        $location, ClientService, TableLiteFactory, toastr
    ) {
        return function () {
                const companiesListTableData = {
                    tableName: 'ClientsListTable',
                    optionAddOns: {
                       
                    },
                    config: {
                        noPagination: false,
                        noHeaders: false,
                        noItemsView: false,
                        noTableFooter: false,
                    },
                    headers: [
                        {
                            label: 'SELECT',
                            class: 'text-center',
                            width: '10',
                            filter: {
                                type: 'checkbox'
                            }
                        },{
                        label: 'Company Name',
                        viewName: 'name',
                        filterName: 'name',
                        filter: {
                            type: 'text',
                            placeholder: 'Search',
                            onSubmit: function(header) {
                                sendRequest(evaluateFilter(header));
                            }
                        },
                        headerFn: function() {
                            sort(this.filterName);
                        }
                    }, {
                        label: 'Account Code',
                        viewName: 'accountCode',
                        filterName: 'accountCode',
                        sortName: 'accountCode',
                        filter: {
                            type: 'text',
                            placeholder: 'Search',
                            onSubmit: function(header){
                                sendRequest(evaluateFilter(header));
                            },
                            model: ''
                        },
                        headerFn: function(){
                            sort(this.sortName);
                        }
                    }, {
                        label: 'Contact Person',
                        viewName: 'contactPerson',
                        filterName: 'contactPerson',
                        sortName: 'primaryContact.firstName',
                        filter: {
                            type: 'text',
                            class: 'bba-ref-no',
                            placeholder: 'Search',
                            onSubmit: function(header) {
                                sendRequest(evaluateFilter(header));
                            },
                            model: '' //optional
                            //text and inputDropdown uses `model` attribute for ng-model
                        },
                        headerFn: function() {
                            sort(this.sortName);
                        }
                    }, {
                        label: 'Email',
                        viewName: 'email',
                        filterName: 'email',
                        filter: {
                            type: 'text',
                            class: 'bba-ref-no',
                            placeholder: 'Search',
                            onSubmit: function(header) {
                                sendRequest(evaluateFilter(header));
                            },
                            model: '' //optional
                            //text and inputDropdown uses `model` attribute for ng-model
                        },
                        headerFn: function() {
                            sort(this.filterName);
                        }
                    }, {
                        label: 'Phone',
                        viewName: 'phoneNumbers',
                        filterName: 'phone1',
                        filter: {
                            type: 'text',
                            class: 'bba-ref-no',
                            placeholder: 'Search',
                            onSubmit: function(header) {
                                sendRequest(evaluateFilter(header));
                            },
                            model: '' //optional
                            //text and inputDropdown uses `model` attribute for ng-model
                        },
                        headerFn: function() {
                            sort(this.filterName);
                        }
                    }, {
                        label: 'Status',
                        viewName: 'status',
                        filterName: 'active',
                        filter: {
                            type: 'select2',
                            placeholder: 'Select One',
                            items: ['Active', 'Inactive'],
                            onSelect: function(header) {
                                const filter = {};
                                filter[header.filterName] = header.filter.model === 'Active';
                                sendRequest(filter);
                            }
                        },
                        headerFn: function() {
                            sort(this.filterName);
                        }
                    }, ],
                    data: []
                };
                const tableActions = new TableLiteFactory(companiesListTableData,
                    {
                        serviceCallback: ClientService.Company.getAll,
                        callbackFormat: ['success','error','filter'],
                        postRequestCallback: data => {
                            buildTableData(data);
                        },
                        postRequestErrorCallback: err => {
                            buildTableData(null);
                            toastr.error(err);
                        },
                        defaultFilters : {
                            size: 5,
                            page: 0,
                            sort: 'id,desc'
                        }
                    }
                );
                const sort = tableActions.sort;
                const evaluateFilter = tableActions.evaluateFilter;
                const sendRequest = tableActions.sendRequest;
    
                function buildTableData(data) {
                    /*** START - Building of Data ***/
    
                    tableActions.initializeTableData(data);
                    if(!data)
                        return null;
                    angular.forEach(data.content, function(client, index) {
                        client.phoneNumbers = {
                            type: 'multiLine',
                            list: []
                        };
    
                        client.id = client.id ? client.id : index;
                        client.companyNo = client.companyNo ? client.companyNo : 'N/A';
                        client.name = client.name ? client.name : 'N/A';
                        client.contactPerson = client.primaryContact ? client.primaryContact.firstName + " " + client.primaryContact.lastName : 'N/A';
                        if(client.primaryContact){
                            client.contactPerson = client.primaryContact.firstName + " " + client.primaryContact.lastName;
    
                            if(client.primaryContact.firstName == "" && client.primaryContact.lastName == ""){
                                client.contactPerson = "N/A";
                            }
                        }
                        client.email = client.email ? client.email : 'N/A';
                        if (client.phone1)
                            client.phoneNumbers.list.push(client.phone1);
                        if (client.phone2)
                            client.phoneNumbers.list.push(client.phone2);
                        if (!client.phone1 && !client.phone2)
                            client.phoneNumbers = 'N/A';
    
                        client.status = {
                            type: 'status',
                            status: client.active,
                            label: client.active ? 'Active' : 'Inactive'
                        }
    
                        client.accountCode = client.accountCode || 'N/A';
                        client.href = '/clients/company/details/' + client.id;
    
                        companiesListTableData.data.push(client);
                    });
                    /*** END - Building of Data ***/
                };
                this.tableData = companiesListTableData;
            }
    }
})();



// WEBPACK FOOTER //
// ./js/services/tables/LinkCompaniesTableService.js